export enum RuleActionType {
  GET_RULES_AND_STATEMENTS_REQUEST = 'GET_RULES_AND_STATEMENTS_REQUEST',
  GET_RULES_AND_STATEMENTS_SUCCESS = 'GET_RULES_AND_STATEMENTS_SUCCESS',
  GET_RULES_AND_STATEMENTS_FAIL = 'GET_RULES_AND_STATEMENTS_FAIL',

  GET_TRANSFORMS_AND_STATEMENTS_REQUEST = 'GET_TRANSFORMS_AND_STATEMENTS_REQUEST',
  GET_TRANSFORMS_AND_STATEMENTS_SUCCESS = 'GET_TRANSFORMS_AND_STATEMENTS_SUCCESS',
  GET_TRANSFORMS_AND_STATEMENTS_FAIL = 'GET_TRANSFORMS_AND_STATEMENTS_FAIL',

  GET_SYSTEMCONFIG_AND_STATEMENTS_REQUEST = 'GET_SYSTEMCONFIG_AND_STATEMENTS_REQUEST',
  GET_SYSTEMCONFIG_AND_STATEMENTS_SUCCESS = 'GET_SYSTEMCONFIG_AND_STATEMENTS_SUCCESS',
  GET_SYSTEMCONFIG_AND_STATEMENTS_FAIL = 'GET_SYSTEMCONFIG_AND_STATEMENTS_FAIL',

  GET_SCHEDULEDRULES_REQUEST = 'GET_SCHEDULEDRULES_REQUEST',
  GET_SCHEDULEDRULES_SUCCESS = 'GET_SCHEDULEDRULES_SUCCESS',
  GET_SCHEDULEDRULES_FAIL = 'GET_SCHEDULEDRULES_FAIL',

  UPDATE_RULES_REQUEST = 'UPDATE_RULES_REQUEST',
  UPDATE_RULES_SUCCESS = 'UPDATE_RULES_SUCCESS',
  UPDATE_RULES_FAIL = 'UPDATE_RULES_FAIL',

  UPDATE_TRANSFORMS_REQUEST = 'UPDATE_TRANSFORMS_REQUEST',
  UPDATE_TRANSFORMS_SUCCESS = 'UPDATE_TRANSFORMS_SUCCESS',
  UPDATE_TRANSFORMS_FAIL = 'UPDATE_TRANSFORMS_FAIL',

  UPDATE_SYSTEMCONFIG_REQUEST = 'UPDATE_SYSTEMCONFIG_REQUEST',
  UPDATE_SYSTEMCONFIG_SUCCESS = 'UPDATE_SYSTEMCONFIG_SUCCESS',
  UPDATE_SYSTEMCONFIG_FAIL = 'UPDATE_SYSTEMCONFIG_FAIL',

  UPDATE_SCHEDULEDRULES_REQUEST = 'UPDATE_SCHEDULEDRULES_REQUEST',
  UPDATE_SCHEDULEDRULES_SUCCESS = 'UPDATE_SCHEDULEDRULES_SUCCESS',
  UPDATE_SCHEDULEDRULES_FAIL = 'UPDATE_SCHEDULEDRULES_FAIL',
}
